var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "",
    "data-name": "arrow-down",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95711 8.83575C8.56658 9.22627 7.93342 9.22627 7.54289 8.83575L4.45711 5.74996C4.26185 5.5547 3.94526 5.5547 3.75 5.74996C3.55474 5.94522 3.55474 6.26181 3.75 6.45707L7.89645 10.6035C8.09171 10.7988 8.40829 10.7988 8.60355 10.6035L12.75 6.45707C12.9453 6.26181 12.9453 5.94522 12.75 5.74996C12.5547 5.5547 12.2382 5.5547 12.0429 5.74996L8.95711 8.83575Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.ef9800da8ac353d1c658ac86ac6b200c.svg";
export { ForwardRef as ReactComponent };